// extracted by mini-css-extract-plugin
module.exports = {"customList":"RenderHTML_customList__uNVlX","dark-overlay":"RenderHTML_dark-overlay__ZYgTC"};